/**
 * @file: 查找拖拽对象
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';

function findDragTarget(allSelect: CubeId[], dragCube: CubeId): DragTargetInfo {
    let dragCubes: Set<CubeId> = new Set();
    let clearCube: Set<CubeId> = new Set();
    let cube: CubeNode = CubeTree.findByCubeId(dragCube);
    let dragType: CubeType = CubeTree.getCubeType(cube);

    allSelect.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);
        let type: CubeType = CubeTree.getCubeType(cube);

        if (type === dragType) {
            dragCubes.add(cubeId);
        }
        else {
            clearCube.add(cubeId);
        }
    });

    // 隔板每次只能拖拽单个
    if (CubeTree.isBafflePlate(dragCube)) {
        dragCubes.forEach((cubeId: CubeId): void => {
            if (cubeId !== dragCube) {
                clearCube.add(cubeId);
                dragCubes.delete(cubeId);
            }
        });
    }

    return {
        dragCube: Array.from(dragCubes),
        clearCube: Array.from(clearCube)
    };
}

export {
    findDragTarget
};
